export enum DailyCardType {
    Quiz = 'Quiz',
    Text = 'Text'
}
